import * as IoC from 'typescript-ioc';
import { ISubWindowFacade, ISubWindowsService, SubWindowStatus } from '../../../infrastructure/sub-windows';
import { IReactIntlProvider } from '../../../infrastructure/react-intl-provider';
import { IntlShape } from 'react-intl';
import { EmailVariablesForm } from './email-variables-form/email-variables-form';
import { EMAIL_VARIABLES_VIEW_LIST_TEXT } from './email-variables.texts';
import { action, observable } from 'mobx';
import { EMAIL_LIST_TYPE } from '../../../constants/email-variables.constants';

class EmailVariablesViewModel {
    @observable
    private variablesPopupFacade: ISubWindowFacade;
    constructor(
        private readonly type: EMAIL_LIST_TYPE,
        @IoC.Inject private readonly subWindowService: ISubWindowsService = IoC.Container.get(ISubWindowsService),
        @IoC.Inject private readonly intlProvider: IReactIntlProvider = IoC.Container.get(IReactIntlProvider),
    ) { }

    public get intl(): IntlShape {
        return this.intlProvider.getIntl();
    }

    @action
    public openPopup = (): void => {
        this.variablesPopupFacade = this.subWindowService.showSubWindow({
            title: this.intl.formatMessage(EMAIL_VARIABLES_VIEW_LIST_TEXT),
            componentToHost: EmailVariablesForm,
            componentToHostProps: {
                type: this.type
            },
            className: 'email-vairables-form',
            showAsFirst: true
        });
    };

    public isVariablesFormHidden = () => {
        return !this.variablesPopupFacade || this.variablesPopupFacade.getStatus() === SubWindowStatus.Closed;
    };
}

export { EmailVariablesViewModel };
